export default {
  schedules: []
};